export enum ResearchInsufficiencyReason {
  MISSING = "missing",
  BLOCKED = "blocked",
  FAILED = "failed",
  // The latest attempt retained valid records but did not finish its search.
  PARTIAL = "partial",
  STALE = "stale",
  BOUND_REACHED = "bound_reached",
}

export const dataByResearchInsufficiencyReason: Record<
  ResearchInsufficiencyReason,
  { label: string }
> = {
  [ResearchInsufficiencyReason.MISSING]: { label: "Not run yet" },
  [ResearchInsufficiencyReason.BLOCKED]: { label: "Blocked" },
  [ResearchInsufficiencyReason.FAILED]: { label: "Failed" },
  [ResearchInsufficiencyReason.PARTIAL]: { label: "Partial" },
  [ResearchInsufficiencyReason.STALE]: { label: "Too old to count" },
  [ResearchInsufficiencyReason.BOUND_REACHED]: {
    label: "Stopped at a run limit",
  },
}
